module.exports = __webpack_public_path__ + "img/Village logo-noir.48b1b4f3.jpg";